<p class="title" mat-dialog-title>{{ "cookieStatementComponent.title" | translate}}<button mat-button
        (click)="onCloseClicked()">{{ "cookieStatementComponent.close" | translate}}</button></p>
<mat-dialog-content>
    <p>{{ "cookieStatementComponent.cookieStatement" | translate}}</p>
</mat-dialog-content>